import type { Dispatch, SetStateAction } from "react";
import React, { useContext } from "react";
import cn from "classnames";

import { useGetVarioqubTestGroup } from "@litres-libs/experiments";
import { useAppSelector } from "@litres-core/store";
import { useTranslation } from "@litres-libs/i18n";

import { getCookie } from "@litres/utils";
import { useGetUserMonetizationData } from "../../../hooks/useGetUserMonetizationData";
import { Tab } from "../../Tab";
import styles from "./NavBar.module.scss";
import { User } from "../../User/User";
import { MyBooks } from "../../MyBooks/MyBooks";
import type { EPopups } from "../../../utils/enums";
import { HeaderContext } from "../../../Header";
import { Bonus } from "../../Bonus/Bonus";

interface INavBarProps {
  openedPopup: EPopups;
  setOpenedPopup: Dispatch<SetStateAction<EPopups>>;
}
export const NavBar = ({
  openedPopup,
  setOpenedPopup,
}: INavBarProps): JSX.Element => {
  const { t } = useTranslation();
  const { isSchoolDomain, isLibraryDomain, isForeignDomain } =
    useContext(HeaderContext);
  const {
    id: userId,
    settings: accountSettings,
    library_info: libraryInfo,
    LKS,
    BSK,
  } = useAppSelector(state => state.foundationUser);
  const { data: userMonetizationData } = useGetUserMonetizationData();
  const isSchoolUser = libraryInfo.is_school_user;
  const loginPopupError = useAppSelector(
    state => state.global.interface.loginPopupError
  );
  const isUserAnonymous = userId === 0;
  const isBonusAbTest = ["true_with_onbording", "true_no_onbording"].includes(
    useGetVarioqubTestGroup("feature_web_llt190")
  );
  const isBonusesEnabledByCookie = [
    "true_with_onbording",
    "true_no_onbording",
  ].includes(getCookie("feature_web_llt190") || "");

  const favoriteCount = isUserAnonymous
    ? LKS.length
    : userMonetizationData?.cart_stats?.deferred_count;

  const basketCount = isUserAnonymous
    ? BSK.length
    : userMonetizationData?.cart_stats?.items_count;

  // На школьном и библио доменах не показываем корзину
  const shouldShowBasket = !isSchoolDomain && !isSchoolUser && !isLibraryDomain;
  // Показываем бонусы только на ru доменах
  const shouldShowBonus =
    (isBonusAbTest || isBonusesEnabledByCookie) &&
    !isForeignDomain &&
    !isSchoolDomain;
  return (
    <nav
      className={styles.navBar}
      aria-label={t("Пользовательские разделы меню")}
    >
      {shouldShowBonus ? (
        <Bonus />
      ) : (
        <Tab type="favorite" count={favoriteCount} />
      )}
      {shouldShowBasket && <Tab type="basket" count={basketCount} />}
      <div className={cn(styles.navBar_flex)}>
        <MyBooks
          isUserAnonymous={isUserAnonymous}
          isLibrary={libraryInfo.is_library_user || false}
          setOpenedPopup={setOpenedPopup}
          openedPopup={openedPopup}
        />
        <User
          isAnon={isUserAnonymous}
          accountSettings={accountSettings}
          isLibrary={isSchoolDomain || isLibraryDomain}
          setOpenedPopup={setOpenedPopup}
          openedPopup={openedPopup}
          loginPopupError={loginPopupError}
        />
      </div>
    </nav>
  );
};
